import { useContext, useState } from "react";
import Link from "next/link";
import useSWR from "swr";
import AppContext from "context/app";
import rideTypes from "utils/rideTypes";
import ClaimCreditPanel from "components/attractions/credit-claim";
import RIDE_CREDIT_QUERY from "queries/ride-credit";

export default function Credit({ attraction, type, setOpen, open }) {
  const [creditOpen, setCreditOpen] = useState(false);

  if (!type) {
    type = "OTHER";
  }

  const { user } = useContext(AppContext);

  const variables = {
    attraction: attraction.id,
    user: user?.id?.toString(),
  };

  const { data, error, mutate } = useSWR(
    user ? [RIDE_CREDIT_QUERY, variables] : null
  );

  if (!user) {
    return (
      <li className="overflow-hidden bg-white px-4 py-4 shadow sm:rounded-md sm:px-6">
        <Link href="/register">
          <a className="inline-block text-gray-900 hover:underline">
            Sign Up to track your rides
          </a>
        </Link>
      </li>
    );
  }

  if (error) {
    console.error(error);
  }

  const count = data?.rideCreditCount || 0;

  return (
    <li className="overflow-hidden bg-white px-4 py-4 shadow sm:rounded-md sm:px-6">
      <p className="mb-2">
        {rideTypes[type].rideCredit.countLine} {count}{" "}
        {`time${count === 1 ? "" : "s"}`}.
      </p>
      <button
        type="button"
        onClick={() => setCreditOpen(true)}
        className="rounded bg-blue-500 py-2 px-4 font-bold text-white hover:bg-blue-700 focus:outline-none focus:ring"
      >
        {rideTypes[type].rideCredit.claimCredit}
      </button>
      <ClaimCreditPanel
        open={creditOpen}
        setOpen={setCreditOpen}
        attraction={attraction}
        mutate={mutate}
      />
    </li>
  );
}
